define('models/wallet_history',['require','backbone'],function(require){

    var Backbone = require('backbone');

    return Backbone.Model.extend({
        defaults: function () {
            return {
                subject: null,
                action_type: 0,
                created: '',
                balance:0,
                currency:"",
                transfer_amount:0,
                recipient_details:{},
                subject_details: {},
                action_details: {products:[]},
                note: null,
                manager_info: ""
            };
        }
    });
});
